import React from "react";
import Skeleton from "react-loading-skeleton";

const StackedStripesLoader = (props) => {
    const { count = 2, stripeWidths = [] } = props;
    const defaultWidth = "100%";
    const widths = stripeWidths.length ? stripeWidths : new Array(count).fill(defaultWidth);
    return (
        <>
            {
                Array.from({ length: count }).map((_, index) => (
                    <div key={index} className="stripe">
                        <Skeleton width={widths[index]} />
                    </div>
                ))
            }
        </>
    )
}

export default StackedStripesLoader